import React from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

type PasswordFieldProps = {
  value: string;
  onChange: (value: string) => void;
  showPassword: boolean;
  onToggleShowPassword: () => void;
  disabled?: boolean;
  helperText?: string;
};

export const PasswordField: React.FC<PasswordFieldProps> = ({
  value,
  onChange,
  showPassword,
  onToggleShowPassword,
  disabled,
  helperText,
}) => (
  <TextField
    fullWidth
    label="Password"
    type={showPassword ? 'text' : 'password'}
    variant="outlined"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder="Enter password"
    disabled={disabled}
    helperText={helperText}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            aria-label={showPassword ? 'hide password' : 'show password'}
            onClick={onToggleShowPassword}
            edge="end"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
);
